import type { FC } from "react";

import classNames from "classnames";

import { ChevronDownIcon } from "@jti/brand-icons/chevron-down";
import { ChevronUpIcon } from "@jti/brand-icons/chevron-up";
import type { LinkBehaviourProps } from "@jti/core-components/components/LinkBehaviour";

import { DEPRECATED_IconButton } from "../DEPRECATED_IconButton";

export type LoadMoreProps = {
  label?: string;
  expanded?: boolean;
} & LinkBehaviourProps;

export const LoadMore: FC<LoadMoreProps> = ({ label = "Load more", expanded, ...props }) => {
  return (
    <DEPRECATED_IconButton
      {...props}
      className={classNames(props.className)}
      icon={expanded ? ChevronUpIcon : ChevronDownIcon}
      iconPosition="end"
    >
      {label}
    </DEPRECATED_IconButton>
  );
};
